import React from "react";

import styles from "./CenteredMessage.module.scss";

type Props = {
  title: React.ReactNode;
  description?: React.ReactNode;
  children?: React.ReactNode;
  maxWidth?: number;
  className?: string;
};

export function CenteredMessage({
  title,
  description,
  children,
  maxWidth = 520,
  className,
}: Props) {
  return (
    <div className={styles.wrapper}>
      <div className={className} style={{ maxWidth }}>
        <h2 className={styles.title}>{title}</h2>
        {description && <p className={styles.description}>{description}</p>}
        {children}
      </div>
    </div>
  );
}
